import React from 'react';
import WeddingGallery from '../components/WeddingGallery';

const WeddingPage = () => {
  return <WeddingGallery />;
};

export default WeddingPage;